import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from "react-router-dom";
const CardContacto =
  ({
    contact,
    selectedContact,
    setIdContact
  }) => {
    function convertirFecha(fechaString) {
      const fecha = new Date(fechaString);
      const dia = fecha.getDate();
      const mes = fecha.getMonth() + 1; // Los meses comienzan desde 0, por lo que se suma 1
      const año = fecha.getFullYear();
      const hora = fecha.getHours();
      const minutos = fecha.getMinutes();
      const diaFormateado = dia < 10 ? '0' + dia : dia;
      const mesFormateado = mes < 10 ? '0' + mes : mes;
      const horaFormateada = hora < 10 ? '0' + hora : hora;
      const minutosFormateados = minutos < 10 ? '0' + minutos : minutos;
      const fechaFormateada =
        `${horaFormateada}:${minutosFormateados}hs - ${diaFormateado}/${mesFormateado}/${año}`;
      return fechaFormateada;
    }

    const sendDetallePath = (contact) => {
      setIdContact(contact.id)
    }

    return (
      <DivRow style={{
        backgroundColor: selectedContact?.id === contact.id ? '#dddddd' : '#FFFFFF'
      }}

        onClick={() => sendDetallePath(contact)}
        key={contact.id}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',

        }} >
          <Text
            selectedContact={selectedContact}
            contact={contact}>
            {contact.name} {contact.lastname}
          </Text>
          <Text
            style={{
              fontSize: '10px',
            }}
            selectedContact={selectedContact}
            contact={contact}>
            {
              contact.Observaciones && contact.Observaciones?.length > 0 ?
                <>
                  {'Último contacto ' + convertirFecha(contact.Observaciones[contact.Observaciones.length - 1].updatedAt)} </> : 'Sin contactar'
            }
          </Text>
        </div>
      </DivRow>
    );
  };

export default CardContacto;

const Text = styled.span`
width: -webkit-fill-available;
font-family: 'Montserrat', sans-serif;
font-weight: 500;
font-size: 14px;
color: ${(prop) => prop.selectedContact?.id === prop.contact.id ? '#07082c' : '#07082c'};
`;

const DivRow = styled.div`
width: -webkit-fill-available;
padding: 8px;
display: flex;
flex-direction: row;
gap: 5px;
height: auto;
align-content: flex-start;
justify-content: start;
align-items: center;
border-top: 1.5px solid #e1e3ea;
box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
cursor: pointer;
background-color: 'transparent' ;
transition: all 0.3s ease-in-out;
&:hover{
    box-shadow: rgba(60, 64, 67, 0.9) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
    opacity: 0.5;
    will-change: transform;
}
&:active{
    will-change: transform;
}
`;

